import React from 'react'
import { ChatterConversation } from '../services/chatterService'
import styles from '../styles/OpportunityListItem.module.css'

interface OpportunityListItemProps {
  conversation: ChatterConversation
  isSelected: boolean
  onClick: () => void
}

const OpportunityListItem: React.FC<OpportunityListItemProps> = ({
  conversation,
  isSelected,
  onClick
}) => {
  const formatLastActivity = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date()
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60))
    
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60))
      return diffInMinutes < 1 ? 'Just now' : `${diffInMinutes}m ago`
    } else if (diffInHours < 24) {
      return `${diffInHours}h ago`
    } else {
      const diffInDays = Math.floor(diffInHours / 24)
      return diffInDays === 1 ? '1 day ago' : `${diffInDays} days ago`
    }
  }

  const truncateMessage = (text: string, maxLength: number = 60) => {
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  return (
    <div 
      className={`${styles.opportunityItem} ${isSelected ? styles.selected : ''} ${conversation.unreadMessages > 0 ? styles.hasUnread : ''}`}
      onClick={onClick}
    >
      {/* Content */}
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.businessName}>
            {conversation.businessName || 'Unknown Business'}
          </h3>
          <span className={styles.lastActivity}>
            {formatLastActivity(conversation.lastActivity)}
          </span>
        </div>

        {conversation.lastMessage ? (
          <div className={styles.lastMessage}>
            <span className={styles.sender}>
              {conversation.lastMessage.senderType === 'iso' ? 'You' : conversation.lastMessage.senderName}:
            </span>
            <span className={styles.messageText}>
              {truncateMessage(conversation.lastMessage.text)}
            </span>
          </div>
        ) : (
          <div className={styles.noMessage}>
            No messages yet
          </div>
        )}
      </div>

      {/* Unread indicator */}
      {conversation.unreadMessages > 0 && (
        <div className={styles.unreadDot}></div>
      )}
    </div>
  )
}

export default OpportunityListItem
